const initialState = {
  isOffline: typeof navigator !== 'undefined' ? !navigator.onLine : false
};

export const isOffline = (state = initialState, action) => {
    if (action.type === 'IS_ONLINE') {
        return {
           ...state,
           isOffline: action.payload
        }
    }
    return state;
}